/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Public_Api_HintInputs */

const cs_blog_public_api_hint = /** @type {(inputs: Blog_Public_Api_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weby načítají publikované články přes GraphQL:`)
};

const en_blog_public_api_hint = /** @type {(inputs: Blog_Public_Api_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Websites fetch published posts via GraphQL:`)
};

/**
* | output |
* | --- |
* | "Websites fetch published posts via GraphQL:" |
*
* @param {Blog_Public_Api_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_public_api_hint = /** @type {((inputs?: Blog_Public_Api_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Public_Api_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_public_api_hint(inputs)
	return cs_blog_public_api_hint(inputs)
});